import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { Card } from '@/@types/card'

interface MockGetCardsPathParams {
  alphaId: string
}

export const mockGetCards = http.get<MockGetCardsPathParams>(
  '/my-business/api/agency/v1/*/:alphaId/cards',
  () => {
    const cards: Card[] = Array.from({ length: 3 }).map(() => ({
      active: faker.datatype.boolean({ probability: 0.9 }),
      brandCode: faker.helpers.arrayElement([
        'VISA',
        'MASTER_CARD',
        'AMERICAN_EXPRESS',
        'ELO',
        'DINERS_CLUB',
        'CREDICARD',
        'GOOD_CARD',
      ]),
      id: faker.number.int({ min: 1000, max: 10000 }),
      companyAlphaId: faker.string.uuid(),
      companyName: faker.company.name(),
      expireDate: faker.date.future().toISOString(),
      holder: faker.person.fullName(),
      truncatedNumber: faker.string
        .numeric({ length: 4 })
        .concat('********')
        .concat(faker.string.numeric({ length: 4 })),
      companyType: faker.helpers.arrayElement([
        'AGENCY_CHAIN',
        'AGENCY',
        'SALES_POINT',
      ]),
      creditCardName: faker.lorem.words(2),
      description: faker.lorem.sentence(),
      shared: faker.datatype.boolean({ probability: 0.9 }),
    }))

    return HttpResponse.json({ data: cards })
  },
)
